export default __webpack_public_path__ + "media/images/features/local_delivery/episode2/LP_03-ef9e540b8dbffca69b5dfddcabc6a9c7.jpg";